<div class="pagination" *ngIf="canShow">
  <button
    type="button"
    class="page-button"
    [disabled]="page <= 0"
    (click)="goTo(0)"
    [attr.title]="translate('first')"
  >
    &laquo;
  </button>
  <button
    type="button"
    class="page-button"
    [disabled]="page <= 0"
    (click)="goTo(page - 1)"
  >
    {{ translate('previous') }}
  </button>
  <span class="page-summary">
    {{ translate('pageOf', { current: page + 1, total: totalPages }) }}
  </span>
  <button
    type="button"
    class="page-button"
    [disabled]="page >= totalPages - 1"
    (click)="goTo(page + 1)"
  >
    {{ translate('next') }}
  </button>
  <button
    type="button"
    class="page-button"
    [disabled]="page >= totalPages - 1"
    (click)="goTo(totalPages - 1)"
    [attr.title]="translate('last')"
  >
    &raquo;
  </button>
</div>
